import type {
  AssignedWorkflow,
  PendingWorkflow,
} from '../../../shared/hooks/useIncidentWorkflow'
import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import {
  Box,
  QuestionCard,
  SteppedList,
  Text,
  questionCardHelperTextStyles,
} from '@hivewatch/dark'

interface WorkflowPendingStateIProps {
  pendingWorkflow: PendingWorkflow
  pendingWorkflowFull: AssignedWorkflow | null
}

export const WorkflowPendingState = ({
  pendingWorkflow,
  pendingWorkflowFull,
}: WorkflowPendingStateIProps) => {
  const mode = useLightMode()
  const { t } = useTranslation()
  const startingStep =
    pendingWorkflowFull?.steps.find(
      (s) => s.id === pendingWorkflowFull.startingStep
    ) ?? pendingWorkflowFull?.steps[0]

  return (
    <SteppedList colorScheme={mode}>
      <Text {...questionCardHelperTextStyles(mode)}>
        {t('incidents:workflow_pending_acknowledgement_subtitle')}
      </Text>
      <Box opacity={0.5} pointerEvents='none' position='relative'>
        <QuestionCard
          answerOptions={
            startingStep?.edges.map((e, i) => ({
              id: String(i),
              label: e.label,
            })) ?? []
          }
          colorScheme={mode}
          question={startingStep?.prompt ?? pendingWorkflow.name}
        />
      </Box>
    </SteppedList>
  )
}
